// extracted by mini-css-extract-plugin
export var cancelButton = "_mm-5";
export var content = "_mm-3";
export var createButton = "_mm-6";
export var drawerContainer = "_mm-0";
export var footer = "_mm-2";
export var header = "_mm-1";
export var orderFormColumn = "_mm-4";